import {
  Add,
  Button,
  FormCard,
  FormItem,
  Input,
  Trash,
  theme
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general/Typography'
import { Form } from 'antd'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { DeleteButtonText } from '../../../styledComponents'
import type { ResidentCareInformationFormType } from '../ResidentCareInformation'

const OtherIdentifierCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <Form.List name="otherIdentifiers">
      {(fields, operations) => (
        <FormCard
          title={t(supConstants.OTHER_IDENTIFIER)}
          rightChildren={
            <Button
              type="button"
              variant="text"
              onClick={() => operations.add()}
            >
              <Add />
              {t(supConstants.ADD_IDENTIFIER)}
            </Button>
          }
        >
          <>
            {fields.map((field) => (
              <Form.Item<ResidentCareInformationFormType>
                key={field.key}
                noStyle
                shouldUpdate={(prevValues, curValues) =>
                  prevValues.otherIdentifiers !== curValues.otherIdentifiers
                }
              >
                {({ getFieldValue }) => (
                  <FormCard
                    key={field.name}
                    level={2}
                    title={
                      getFieldValue(['otherIdentifiers', field.name, 'type']) ||
                      `${t(supConstants.IDENTIFIER)} ${field.key + 1}`
                    }
                    rightChildren={
                      <Button
                        variant="text"
                        type="button"
                        icon={<Trash color={theme.color.neutral.color4} />}
                        onClick={() => operations.remove(field.name)}
                      >
                        <DeleteButtonText>
                          {t(supConstants.DELETE_IDENTIFIER)}
                        </DeleteButtonText>
                      </Button>
                    }
                  >
                    <FormItem
                      label={<Text>{t(supConstants.IDENTIFIER)}</Text>}
                      name={[field.name, 'identifier']}
                    >
                      <Input />
                    </FormItem>
                    <FormItem
                      label={<Text>{t(supConstants.TYPE)}</Text>}
                      name={[field.name, 'type']}
                    >
                      <Input />
                    </FormItem>
                  </FormCard>
                )}
              </Form.Item>
            ))}
          </>
        </FormCard>
      )}
    </Form.List>
  )
}

export default OtherIdentifierCard
